interface Timezones {
  gmt: string;
  locale: string;
  value: string;
}

const timezones: Timezones[] = [
  { gmt: 'GMT-10:00', locale: 'Honolulu', value: 'Pacific/Honolulu' },
  { gmt: 'GMT-09:00', locale: 'Anchorage', value: 'America/Anchorage' },
  { gmt: 'GMT-08:00', locale: 'Los Angeles', value: 'America/Los_Angeles' },
  { gmt: 'GMT-07:00', locale: 'Denver', value: 'America/America/Denver' },
  { gmt: 'GMT-06:00', locale: 'Cidade do México', value: 'America/Mexico_City' },
  { gmt: 'GMT-06:00', locale: 'Chicago', value: 'America/Chicago' },
  { gmt: 'GMT-05:00', locale: 'Rio Branco (Acre)', value: 'America/Rio_Branco' },
  { gmt: 'GMT-05:00', locale: 'Bogotá', value: 'America/Bogota' },
  { gmt: 'GMT-05:00', locale: 'Nova Iorque', value: 'America/New_York' },
  { gmt: 'GMT-05:00', locale: 'Lima', value: 'America/Lima' },
  { gmt: 'GMT-04:00', locale: 'Santiago', value: 'America/Santiago' },
  { gmt: 'GMT-04:00', locale: 'Manaus', value: 'America/Manaus' },
  { gmt: 'GMT-04:00', locale: 'Caracas', value: 'America/Caracas' },
  { gmt: 'GMT-03:00', locale: 'Brasília', value: 'America/Sao_Paulo' },
  { gmt: 'GMT-03:00', locale: 'Montevideo', value: 'America/Montevideo' },
  {
    gmt: 'GMT-03:00',
    locale: 'Buenos Aires',
    value: 'America/Argentina/Buenos_Aires',
  },
  { gmt: 'GMT-02:00', locale: 'Fernando de Noronha', value: 'America/Noronha' },
  { gmt: 'GMT-01:00', locale: 'Cabo Verde', value: 'Atlantic/Cape_Verde' },
  { gmt: 'GMT+00:00', locale: 'Londres', value: 'Europe/London' },
  { gmt: 'GMT+00:00', locale: 'Casablanca', value: 'Africa/Casablanca' },
  { gmt: 'GMT+01:00', locale: 'Lagos', value: 'Africa/Lagos' },
  { gmt: 'GMT+01:00', locale: 'Paris', value: 'Europe/Paris' },
  { gmt: 'GMT+02:00', locale: 'Johannesburgo', value: 'Africa/Johannesburg' },
  { gmt: 'GMT+02:00', locale: 'Cairo', value: 'Africa/Cairo' },
  { gmt: 'GMT+03:00', locale: 'Nairóbi', value: 'Africa/Nairobi' },
  { gmt: 'GMT+04:00', locale: 'Emirados Arabes Unidos', value: 'Asia/Dubai' },
  { gmt: 'GMT+05:00', locale: 'Maldivas', value: 'Indian/Maldives' },
  { gmt: 'GMT+06:00', locale: 'Dhaka', value: 'Asia/Dhaka' },
  { gmt: 'GMT+07:00', locale: 'Bangkok', value: 'Asia/Bangkok' },
  { gmt: 'GMT+08:00', locale: 'Pequim', value: 'Asia/Shanghai' },
  { gmt: 'GMT+09:00', locale: 'Tóquio', value: 'Asia/Tokyo' },
  { gmt: 'GMT+10:00', locale: 'Sydney', value: 'Australia/Sydney' },
  { gmt: 'GMT+11:00', locale: 'Sakhalin', value: 'Asia/Sakhalin' },
  { gmt: 'GMT+12:00', locale: 'Fiji', value: 'Pacific/Fiji' },
  { gmt: 'GMT+13:00', locale: 'Tonga', value: 'Pacific/Tongatapu' },
  { gmt: 'GMT+14:00', locale: 'Kiritimati', value: 'Pacific/Kiritimati' },
];

export default timezones;
export const BRASILIA_TIMEZONE = 'America/Sao_Paulo';
